const features = [
  {
    title: '海量片库',
    desc: '收录超过10,000部影片，涵盖动作、喜剧、科幻、爱情、恐怖等全品类电影，满足各类观影需求。',
    icon: 'ri-database-2-line',
    color: 'primary',
  },
  {
    title: '每日更新',
    desc: '片库每天新增30部以上影片，最新上映的院线大片和热门电影第一时间上架，永不错过精彩。',
    icon: 'ri-refresh-line',
    color: 'accent',
  },
  {
    title: '高清画质',
    desc: '大部分影片支持1080P高清播放，热门院线大片可达超清画质，带来沉浸式观影体验。',
    icon: 'ri-4k-line',
    color: 'secondary',
  },
  {
    title: '分类精准',
    desc: '提供电影类型、年代、评分等多维度分类筛选，帮你快速定位心仪影片，找片效率翻倍。',
    icon: 'ri-filter-2-line',
    color: 'primary',
  },
  {
    title: '多端适配',
    desc: '全面适配手机、平板和电脑端，无论使用什么设备访问，都能获得流畅的浏览和观影体验。',
    icon: 'ri-smartphone-line',
    color: 'accent',
  },
];

export default function FeaturesSection() {
  const getColorClasses = (color: string) => {
    switch (color) {
      case 'primary':
        return {
          bg: 'bg-primary-50',
          iconBg: 'bg-primary-100',
          icon: 'text-primary-600',
          border: 'hover:border-primary-200',
        };
      case 'accent':
        return {
          bg: 'bg-accent-50',
          iconBg: 'bg-accent-100',
          icon: 'text-accent-600',
          border: 'hover:border-accent-200',
        };
      case 'secondary':
        return {
          bg: 'bg-secondary-50',
          iconBg: 'bg-secondary-100',
          icon: 'text-secondary-600',
          border: 'hover:border-secondary-200',
        };
      default:
        return {
          bg: 'bg-primary-50',
          iconBg: 'bg-primary-100',
          icon: 'text-primary-600',
          border: 'hover:border-primary-200',
        };
    }
  };

  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            平台特色
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            为什么选择小草影院？这里有你想知道的一切
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((item, i) => {
            const colors = getColorClasses(item.color);
            return (
              <div
                key={i}
                className={`group bg-background-50 rounded-xl p-6 border border-background-200/70 ${colors.border} transition-all duration-200 cursor-pointer text-center`}
              >
                <div className={`w-12 h-12 mx-auto flex items-center justify-center rounded-xl ${colors.iconBg} mb-4`}>
                  <i className={`${item.icon} ${colors.icon} text-xl`}></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 font-heading">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}